import React, { useEffect, useState, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Navbar from "../../Navbar/Navbar.js";
import SliderPage from "./SliderPage.js";
// import digitalService from "../../../Images/digitalService.jpg"
import digitalService from "../../../Images/Digital-transformation-services1.jpg";
import Digital from "../../../Images/Digital-transformation-services.svg";
import { ReactComponent as Bulb } from "../../../Images/bulb.svg";
import { ReactComponent as Efficient } from "../../../Images/efficient.svg";
import { ReactComponent as Person } from "../../../Images/person.svg";
import { ReactComponent as Insights } from "../../../Images/dataInsight.svg";
import { ReactComponent as Trophy } from "../../../Images/trophy.svg";
import Footer from "../../Footer/Footer.js";
import DetailsCard, { ThreeColumnContainer } from "./DetailsCard.js";
import cardData from "../../../resources/cardData.json";
import imageHeader from "../../../resources/imageHeader.json";
import ImageHeader from "./ImageHeader.js";
import SubHeadings from "./SubHeadings.js";
import Header, {
  NavLink,
  NavLinks,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../../Navbar/Navbar.js";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./BreadCrumbs.js";
import ContactUsButton from "./ContactUsButton.js";
import TechStack1 from "./TechStack1.js";
import ImageHeaderMain from "./ImageHeaderMain.js";
import logoTextData from "../../../resources/logoTextData.json";
import IconCard from "./IconCard.js";
import { ReactComponent as Code } from "feather-icons/dist/icons/code.svg";
import { ReactComponent as Database } from "feather-icons/dist/icons/database.svg";
import { ReactComponent as Location } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as Dollar } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Message } from "feather-icons/dist/icons/message-square.svg";
import { ReactComponent as Key } from "feather-icons/dist/icons/key.svg";

const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none text-gray-800 bg-white z-10`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const Navtabs = styled.div`
  ${tw`max-w-screen-xl mx-auto m-3 sticky`}
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-pink-700 opacity-25`;
const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-2xl mx-auto`;
const ContainerNav = styled.div`
  ${tw`relative`}
`;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-20`;
const Description = tw.p`px-6 font-semibold py-5 my-10 text-sm md:text-xl text-gray-900 text-center`;
const TwoCol = styled.div`
  ${tw`flex justify-between max-w-screen-xl mx-auto`}
`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto shadow-lg`;
const Navtabslink = tw.p`inline-flex items-center border-b-2 border-transparent hover:cursor-pointer hover:border-primary-700 font-semibold text-black`;

let data = [
  {
    imageSrc: <Bulb />,
  },
  {
    imageSrc: <Efficient />,
  },
  {
    imageSrc: <Person />,
  },
  {
    imageSrc: <Trophy />,
  },
  {
    imageSrc: <Insights />,
  },
];
const keyBenefits = cardData.digital.keyBenefits.map((item, index) => (
  <DetailsCard
    key={index}
    title={item.point}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));
const imgStyle = { width: "40px", height: "40px" };
let integrationData = [
  {
    imageSrc: <Location style={imgStyle} />,
  },
  {
    imageSrc: <Database style={imgStyle} />,
  },
  {
    imageSrc: <Code style={imgStyle} />,
  },
  {
    imageSrc: <Dollar style={imgStyle} />,
  },
  {
    imageSrc: <Message style={imgStyle} />,
  },
  {
    imageSrc: <Key style={imgStyle} />,
  },
];

const integrationSpecialities =
  logoTextData.thirdpartyintegrations.integrationspecialities.map(
    (item, index) => (
      <IconCard
        readmore={true}
        key={index}
        title={item.title}
        url={item.url}
        description={item.description}
        imageSrc={integrationData[index].imageSrc}
      />
    )
  );
const styles = `
.active {
  font-weight: semibold;
  color: #f56565;
  // color: #6415ff;
  // border-bottom: 1px solid #f56565;
}
`;

const DigitalService = () => {
  let [current, setCurrent] = useState(0);
  let previousSlide = () => {
    if (current === 0) setCurrent(slides.length - 1);
    else setCurrent(current - 1);
  };

  let nextSlide = () => {
    if (current === slides.length - 1) setCurrent(0);
    else setCurrent(current + 1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const divs = document.querySelectorAll(".div-class");
      let topDiv = null;
      let minTop = Infinity;

      divs.forEach((div) => {
        const { top } = div.getBoundingClientRect();
        if (top >= 0 && top < window.innerHeight && top < minTop) {
          minTop = top;
          topDiv = div.id;
        }
      });

      setActiveSection(topDiv);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(nextSlide, 5000); // Change 5000 to adjust interval time (in milliseconds)
    return () => clearInterval(intervalId);
  }, [current]);
  let slidesData = [
    {
      image: digitalService,
      typeID: "element5",
      typedHead:
        "Leverage new technologies from maps, messaging and other online tools to enhance your business.",
      heading1: "Digital ",
      heading2: "transformation services",
      route: "/what-we-do/digital-transformation-services",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];
  const [activeSection, setActiveSection] = useState(null);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    document.title = "Welcome to Iqura - Digital Transformation Services";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Iquras experts offer a wide variety of Digital Transformation services to enhance your processes and facilitate growth and scalability"
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      " Seamless digital interactions, Digital Transformation Services | Strategy, Solutions and Consulting"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href =
      "https://www.iqura.tech/what-we-do/digital-transformation-services";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setTimeout(() => {
      setAnimate(false);
    }, 1400);
  }, []);

  const styles = `
.active {
  font-weight: semibold;
  color: #f56565;
  // color: #6415ff;
  // border-bottom: 1px solid #f56565;
}
`;

  const [currentColor, setCurrentColor] = useState("%23EEF5FF");
  const svgStyle = {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='${currentColor}' fill-opacity='0.9' d='M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,80C960,75,1056,85,1152,117.3C1248,149,1344,203,1392,229.3L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z'/%3E%3C/svg%3E")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "350px",
  };

  const navigate = useNavigate();
  const navLinks = [
    <NavLinks key={1}>
      <NavLink onClick={() => navigate("/", { state: "whatwedo" })}>
        What we do
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "ourservices" })}>
        Services
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "techstack" })}>
        Techstack
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "whoweare" })}>
        Who we are
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "career" })}>
        Careers
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "contact" })}>
        Contact
      </NavLink>
    </NavLinks>,
  ];
  const childRef = useRef(null);
  const handleBreadCrumbClose = () => {
    if (childRef.current) {
      childRef.current.handleClick();
    }
  };

  function handleNavbarScroll(id, value) {
    // setCurrentNav(id);
    let idList = ["benefits", "integrations", "techstack"];
    for (let i = 0; i < idList.length; i++) {
      if (id != idList[i]) {
        document.getElementById(idList[i]).style.paddingTop = "0px";
      }
    }

    document.getElementById(id).style.paddingTop = value;
    var eleme = document.getElementById(id);
    eleme.scrollIntoView({
      behavior: "smooth",
    });
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        let idList = ["benefits", "integrations", "techstack"];
        for (let i = 0; i < idList.length; i++) {
          document.getElementById(idList[i]).style.paddingTop = "0px";
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navLink = [
    {
      section: "Key benefits",
      label: "Key benefits",
      scrollTo: "benefits",
      width: `${window.innerWidth <= 425 ? 210 : 130}px`,
    },
    {
      section: "Third Party Integrations",
      label: "Third Party Integrations",
      scrollTo: "integrations",
      width: `${window.innerWidth <= 425 ? 210 : 130}px`,
    },
    {
      section: "Our Techstack",
      label: "Our Techstack",
      scrollTo: "techstack",
      width: `${window.innerWidth <= 425 ? 110 : 60}px`,
    },
  ];

  const navLinksRendered = navLink.map((link) => (
    <Navtabslink
      style={{ backgroundColor: "#eef5ff" }}
      key={link.section}
      className={activeSection === link.scrollTo ? "active" : ""}
      onClick={() => handleNavbarScroll(link.scrollTo, link.width)}
    >
      {link.label}
    </Navtabslink>
  ));

  return (
    <>
      <Navbar className="shadow-md" />
      <ContainerNav>
        <OpacityOverlay />
        <HeroContainer>
          <StyledHeader links={navLinks} />
        </HeroContainer>
      </ContainerNav>
      <BreadCrumbs
        ref={childRef}
        title={"Digital Transformation Services"}
        title1={"What we do"}
      />
      <ContactUsButton />
      <div className="overflow-hidden relative  ">
        <div
          className="flex transition-transform ease-out duration-300 "
          style={{
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {slides.map((s) => {
            return (
              <div className="z-22" style={{ width: "100%" }}>
                {s}
              </div>
            );
          })}
        </div>

        <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
          {slides.map((s, i) => {
            return (
              <div
                onClick={() => {
                  setCurrent(i);
                }}
              ></div>
            );
          })}
        </div>
      </div>
      <style>{styles}</style>
      <Container onClick={handleBreadCrumbClose}>
        <TwoCol>
          <WrapperDescription>
            <Description
              style={{
                backgroundColor: "white",
                marginTop: `${window.innerWidth <= 425 ? -140 : -200}px`,
                padding: "40px",
              }}
            >
              <ImageHeader
                imageHeaderData={imageHeader.Digital}
                imgsource={Digital}
              />
            </Description>
          </WrapperDescription>
        </TwoCol>
        <div>
          <Navtabs
            style={{
              // backgroundColor: "#eef5ff",
              // backgroundColor: "#e2e8f0",
              // backgroundColor: "#ffffff",
              // position: "sticky",
              top: "78px",
              zIndex: "2",
            }}
          >
            <div className="flex 	 justify-center lg:gap-12 gap-4 p-2  mx-2 mt-8 flex-wrap ">
              <div
                style={{ backgroundColor: "#eef5ff" }}
                className="flex shadow-md justify-center lg:gap-12 gap-4 p-2  px-10 flex-wrap "
              >
                {navLinksRendered}
              </div>
              {/* <Navtabslink onClick={()=>scrollFooter()}>Footer</Navtabslink> */}
            </div>
          </Navtabs>
          <Wrapper>
            <div id="benefits" className="div-class"></div>
            <SubHeadings heading1="Key" heading2="benefits" />
            <ThreeColumnContainer>{keyBenefits}</ThreeColumnContainer>
            <div id="integrations" className="div-class"></div>
            <SubHeadings heading1="Third Party" heading2="Integrations" />
            {/* <DescriptionContainer data={cardData.Digital.howItWorks} /> */}
            <ThreeColumnContainer>
              <Description>
                Our capabilities and experience with third-party systems and
                APIs will help you maximize your workflows with efficient and
                seamless integrations with your existing systems.
              </Description>
            </ThreeColumnContainer>
            <ThreeColumnContainer>
              {integrationSpecialities}
            </ThreeColumnContainer>
            <div id="techstack" className="div-class"></div>
            <SubHeadings heading1="Our" heading2="Techstack" />
            <TechStack1 />
          </Wrapper>
          {/* <LogosCard /> */}
          <Footer />
        </div>
      </Container>
    </>
  );
};

export default DigitalService;
